import React from "react";
import { bannerImg } from "../../assets/index";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      <img
        className="w-[300px] h-[400px] lgl:w-[500px] lgl:h-[680px] z-10 object-cover rounded-2xl ring-1 ring-white/10"
        src={bannerImg}
        alt="bannerImg"
      />
      <div className="absolute bottom-0 w-[300px] h-[300px] lgl:w-[500px] lgl:h-[500px] rounded-2xl bg-gradient-to-tr from-indigo-600/20 via-slate-900/40 to-cyan-500/10 border border-white/10 shadow-astraGlow blur-[1px]"></div>
    </div>
  );
};

export default RightBanner;
